import React, { useRef } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { useHeroImageForContainer } from '@wix/da-shared-react/pkg/utils/hooks/useHeroImageForContainer';
import Attribution from './Attribution';
import s from './ArtBackdrop.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  artClassName?: string;
  attributionClassName?: string;
  artStyle?: Record<string, any>;
}

/** Covers it's container in full-size deviation, artist attribution,
 *  and gradients for better contrast of overlaid text */
export const ArtBackdrop: React.FC<Props> = ({
  deviation,
  className,
  artClassName,
  artStyle,
  attributionClassName,
}) => {
  const rootDivRef = useRef<HTMLDivElement>(null);
  const { hero } = useHeroImageForContainer(deviation, rootDivRef);
  if (!hero) {
    return null;
  }

  // send attribution clicks to the bg/deviation and not the author's profile
  const attributionUrl = Url.deviationLink(
    deviation.deviationId,
    deviation.author?.username,
    deviation.title
  );
  return (
    <figure className={classnames(s['root'], className)} ref={rootDivRef}>
      <img
        className={classnames(s['art'], artClassName)}
        src={hero.src}
        alt=""
        style={artStyle}
      />
      <div className={s['gradient']} />
      <div className={s['gradient']} />
      <div className={s['gradient']} />
      <Attribution
        className={classnames(s['attribution'], attributionClassName)}
        author={deviation.author}
        url={attributionUrl}
      />
    </figure>
  );
};
ArtBackdrop.displayName = 'ArtBackdrop';
export default ArtBackdrop;
